import Vue from 'vue'
import moment from "moment/moment"

// 手机号码 xxx xxxx xxxx
Vue.filter('mobileSpace', value => {
    if (value) {
        value = value.split('')
        value[2] += ' '
        value[6] += ' '
        return value.join('')
    }
})

// 手机号码 xxx****xxxx
Vue.filter('mobileHide', value => {
    if (value) {
        value = value.split('')
        for (let i = 3; i < 7; i++) {
            value.splice(i, 1, '*')
        }
        return value.join('')
    }
})

// 银行卡号 xxxx xxxx xxxx...
Vue.filter('bankSpace', value => {
    if (value) {
        value = value.split('')
        for (let i = 3; i < value.length; i += 4) {
            value[i] += ' '
        }
        return value.join('')
    }
})

// 银行卡号 xxxx **** ****... xxxx
Vue.filter('bankHide', value => {
    if (value) {
        value = value.split('')
        for (let i = 3; i < value.length; i += 4) {
            value[i] += ' '
        }
        value = value.join('').split(' ')

        for (let i = 1; i < value.length - 1; i++) {
            value[i] = '****'
        }
        return value.join(' ')
    }
})

// 银行卡号 xxxx **** **** xxxx
Vue.filter('bankCenterHide', value => {
    if (value) {
        return value.substr(0, 4) + " **** **** " + value.substr(-4)
    }
})

Vue.filter('time', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss'
    return moment(value).format(formatString)
})
//| readMore(5,'...') 文字...
Vue.filter('readMore', (value, length, suffix) => {
    if (value && value.toString().length > length) {
        return value.substring(0, length) + suffix
    } else {
        return value
    }
})



// WEBPACK FOOTER //
// ./src/utils/filters.js